import { initBrowserSentry } from './sentry/init-browser-sentry'
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import morph from '@alpinejs/morph'
import persist from '@alpinejs/persist'
import precognition from 'laravel-precognition-alpine'
import htmx from 'htmx.org'
import Swup from 'swup'
import SwupPreloadPlugin from '@swup/preload-plugin'
import dataInNumbersComponent from './c-data-in-numbers'
import timelineComponent from './c-timeline'
import paginationComponent from './c-pagination'
import slideComponent from './c-slider'
import lightboxComponent from './c-lightbox'
import cookiesManager from './c-cookies-manager'
import valueChain from './c-value-chain.js'
import localeChange from './c-locale-change.js'
import { observersStore } from './store/observers'
import { appStore } from './store/app'
import { debounce } from './utils'
import { initAos } from './aos'

initBrowserSentry()

document.body.addEventListener('htmx:configRequest', (evt) => {
    evt.detail.headers['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').content
})

Alpine.store('app', appStore)
Alpine.store('observers', observersStore)
Alpine.data('dataInNumbersComponent', dataInNumbersComponent)
Alpine.data('timelineComponent', timelineComponent)
Alpine.data('paginationComponent', paginationComponent)
Alpine.data('slideComponent', slideComponent)
Alpine.data('lightboxComponent', lightboxComponent)
Alpine.data('cookiesManager', cookiesManager)
Alpine.data('valueChain', valueChain)
Alpine.data('localeChange', localeChange)
Alpine.plugin([collapse, morph, persist, precognition])

window.Alpine = Alpine

Alpine.start()

const handleResize = () => {
    Alpine.store('app').isMobile = window.innerWidth < 1024
}
window.addEventListener('resize', debounce(handleResize, 200))

window.htmx = htmx

const swup = new Swup({
    containers: ['#swup'],
    plugins: [new SwupPreloadPlugin()],
    cache: true,
})

document.addEventListener('DOMContentLoaded', () => {
    initAos()
})

swup.hooks.on('page:view', () => {
    initAos()
    htmx.process(document.body)
})
